/* jshint esversion: 11 */
/* jshint ignore:start */

import { useContext, useState, useEffect, useRef } from "react";
import axios from "axios";
import Callicon from "../../Icon/call.svg";
import { MyContext } from "../../Context/MyProvider";
import { showTost } from "../../showTost";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaUserCheck } from "react-icons/fa";

const Login = () => {
  const { t } = useTranslation();
  const { setIsLoginShow, setIsSignUpShow, setIsLogin, isShowBtn } =
    useContext(MyContext);
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [otpType, setOtpType] = useState("");
  const [page, setPage] = useState("LOGIN");

  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);

  const inputRefs = useRef([]);
  const hiddenInputRef = useRef(null);

  const focusOtpInput = () => {
    let attempts = 0;

    const tryFocus = () => {
      if (attempts > 5) return;

      if (hiddenInputRef.current) {
        hiddenInputRef.current.focus();

        // small trick to trigger iOS keyboard
        hiddenInputRef.current.click();
      }

      attempts++;
      setTimeout(tryFocus, 600);
    };

    tryFocus();
  };

  // ================= AUTO FOCUS =================
  // useEffect(() => {
  //   if (page === "OTP") {
  //     setTimeout(() => {
  //       hiddenInputRef.current?.focus(); // ✅ important for autofill
  //     }, 200);
  //   }
  // }, [page]);

  useEffect(() => {
    if (page === "OTP") {
      setTimeout(() => {
        focusOtpInput(); // ✅ use new function
      }, 300);
    }
  }, [page]);

  // ================= SEND OTP =================
  const handleSendOtp = async () => {
    if (phone.length !== 10) {
      showTost(t("Enter valid 10 digit mobile number"), "error");
      return;
    }

    try {
      const res = await axios.post(
        "https://yblapis.ganpatigroupbharat.com/api/auth/send_otp",
        { mobile: phone }
      );

      if (res.data?.status) {
        setOtpType(res.data?.data?.[0]?.type || "");
        showTost(t("OTP sent successfully"), "success");
        setPage("OTP");
        setTimer(60);
        setCanResend(false);
      } else {
        showTost(res.data?.msg || t("User Not Registered"), "error");
      }
    } catch {
      showTost(t("Server error"), "error");
    }
  };

  // ================= TIMER =================
  useEffect(() => {
    let interval;

    if (page === "OTP" && !canResend) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [page, canResend]);

  // ================= VERIFY OTP =================
  const handleVerifyOtp = async () => {
    const otpValue = otp.join("");

    if (otpValue.length !== 6) {
      showTost(t("Enter valid 6 digit OTP"), "error");
      return;
    }

    try {
      const res = await axios.post(
        "https://yblapis.ganpatigroupbharat.com/api/auth/verify_mobile_otp",
        { mobile: phone, otp: otpValue, type: otpType }
      );

      if (res.data?.status && res.data?.userExist) {
        showTost(t("Login successful"), "success");

        localStorage.setItem("LoginData", JSON.stringify(res.data.user));
        localStorage.setItem("Userid", res.data.user.loginid);

        setIsLogin(true);
        setIsLoginShow(false);
        navigate("/");
      } else {
        setIsLoginShow(false);
        setIsSignUpShow(true);
        localStorage.setItem("mobile", phone);
      }
    } catch {
      showTost(t("OTP verification failed"), "error");
    }
  };

  // ================= AUTO SUBMIT =================
  // useEffect(() => {
  //   if (otp.join("").length === 6) {
  //     handleVerifyOtp();
  //   }
  // }, [otp]);

  return (
    <>
      {isShowBtn ? (
        <div>
          {/* LOGIN */}
          {page === "LOGIN" && (
            <div className="py-[10px] sm:px-[20px] login-box">
              <h1 className="text-[22px] font-bold">
                {t("Sign in to Nabhiverse")}
              </h1>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSendOtp();
                }}
              >
                <div className="relative login-input mt-[20px] flex items-center">
                  <img src={Callicon} className="w-[25px] mr-2" alt="" />
                  <span className="mr-2 font-medium text-white">+91</span>

                  <input
                    type="tel"
                    value={phone}
                    placeholder={t("Enter mobile number")}
                    maxLength={10}
                    onChange={(e) => {
                      const digits = e.target.value.replace(/\D/g, "");
                      setPhone(digits);
                    }}
                    className="w-full outline-none bg-transparent"
                  />
                </div>

                <button type="submit" className="button mt-[20px]">
                  {t("Send OTP")}
                </button>
              </form>
            </div>
          )}

          {/* OTP */}
          {page === "OTP" && (
            <div className="py-[10px] sm:px-[20px] login-box">
              <h1 className="text-center font-bold">{t("Enter OTP")}</h1>

              <p className="text-center text-white mt-2">
                {t("OTP sent to")} <b>+91 {phone}</b>
              </p>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleVerifyOtp();
                }}
              >
                <div className="login-input mt-[20px] flex gap-2 justify-center relative">

                  {/* 🔥 Hidden input for autofill */}
                  <input
                    ref={hiddenInputRef}
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    className="absolute opacity-0 pointer-events-none"
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "").slice(0, 6);
                      if (!val) return;

                      const digits = val.split("");
                      setOtp([...digits, ...Array(6 - digits.length).fill("")]);

                      setTimeout(() => {
                        inputRefs.current[digits.length - 1]?.focus();
                      }, 0);
                    }}
                  />

                  {/* OTP BOXES */}
                  {otp.map((digit, i) => (
                    <input
                      key={i}
                      ref={(el) => (inputRefs.current[i] = el)}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      autoComplete="off"
                      className="otp-box text-center"
                      value={digit}

                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        if (!val) return;

                        const newOtp = [...otp];
                        newOtp[i] = val;
                        setOtp(newOtp);

                        if (i < 5) inputRefs.current[i + 1]?.focus();
                      }}

                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          const newOtp = [...otp];
                          newOtp[i] = "";
                          setOtp(newOtp);

                          if (i > 0) inputRefs.current[i - 1]?.focus();
                        }
                      }}

                      onPaste={(e) => {
                        e.preventDefault();
                        const paste = e.clipboardData
                          .getData("text")
                          .replace(/\D/g, "")
                          .slice(0, 6);

                        if (!paste) return;

                        const digits = paste.split("");
                        setOtp([...digits, ...Array(6 - digits.length).fill("")]);

                        setTimeout(() => {
                          inputRefs.current[digits.length - 1]?.focus();
                        }, 0);
                      }}
                    />
                  ))}
                </div>

                <button type="submit" className="button mt-[20px]">
                  {t("Verify & Login")}
                </button>
              </form>

              <h1 className="mt-[10px] text-center text-white">
                {t("Don't have received otp?")}{" "}
                {canResend ? (
                  <button
                    onClick={() => {
                      handleSendOtp();

                      // 🔥 important: re-focus after resend
                      setTimeout(() => {
                        focusOtpInput();
                      }, 500);
                    }}
                    className="text-[#a33cff] font-semibold"
                  >
                    {t("Resend OTP")}
                  </button>
                ) : (
                  <span className="text-[#a33cff] font-semibold">
                    {t("Resend in")} {timer}s
                  </span>
                )}
              </h1>
            </div>
          )}
        </div>
      ) : (
        <div className="login-box flex items-center gap-3">
          <FaUserCheck className="text-[#8c26ff] text-[30px]" />
          <div>
            <h1 className="text-[18px] font-semibold">
              {t("Already Logged In")}
            </h1>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;

/* jshint ignore:end */
